import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  HostBinding
} from '@angular/core';

@Component({
  selector: 'awair-info-popup',
  templateUrl: './info-popup.component.html',
  styleUrls: ['./info-popup.component.scss']
})

export class InfoPopupComponent implements OnInit {
  @HostBinding('style.position') position = 'absolute';
  @HostBinding('style.visibility') visibility = 'block';

  @Input() componentType: string;
  @Input() isOpened: boolean = false;

  @Output() close: EventEmitter<any> = new EventEmitter();

  constructor(public el: ElementRef) { }

  ngOnInit() {
  }

  closePopup() {
    this.close.emit();
  }
}
